module.exports = __webpack_public_path__ + "img/maltlogo.4b1da6dd.webp";